import { api } from '@/shared/lib/api';
import type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
  RefreshRequest,
  RefreshResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  VerifyEmailRequest,
  ChangePasswordRequest,
  SessionsResponse,
  SelectTenantRequest,
  SelectTenantResponse,
  MessageResponse,
} from '../types/auth.types';

const AUTH = '/auth';

export async function login(data: LoginRequest): Promise<LoginResponse> {
  const res = await api.post<LoginResponse>(`${AUTH}/login`, data);
  return res.data;
}

export async function register(data: RegisterRequest): Promise<RegisterResponse> {
  const res = await api.post<RegisterResponse>(`${AUTH}/register`, data);
  return res.data;
}

export async function refreshToken(data: RefreshRequest): Promise<RefreshResponse> {
  const res = await api.post<RefreshResponse>(`${AUTH}/refresh`, data);
  return res.data;
}

export async function logout(): Promise<void> {
  await api.post(`${AUTH}/logout`);
}

export async function forgotPassword(data: ForgotPasswordRequest): Promise<MessageResponse> {
  const res = await api.post<MessageResponse>(`${AUTH}/forgot-password`, data);
  return res.data;
}

export async function resetPassword(data: ResetPasswordRequest): Promise<MessageResponse> {
  const res = await api.post<MessageResponse>(`${AUTH}/reset-password`, data);
  return res.data;
}

export async function verifyEmail(data: VerifyEmailRequest): Promise<MessageResponse> {
  const res = await api.post<MessageResponse>(`${AUTH}/verify-email`, data);
  return res.data;
}

export async function resendVerification(email: string): Promise<MessageResponse> {
  const res = await api.post<MessageResponse>(`${AUTH}/resend-verification`, { email });
  return res.data;
}

export async function changePassword(data: ChangePasswordRequest): Promise<MessageResponse> {
  const res = await api.post<MessageResponse>(`${AUTH}/change-password`, data);
  return res.data;
}

export async function getSessions(): Promise<SessionsResponse> {
  const res = await api.get<SessionsResponse>(`${AUTH}/sessions`);
  return res.data;
}

export async function revokeSession(sessionId: string): Promise<void> {
  await api.delete(`${AUTH}/sessions/${sessionId}`);
}

export async function selectTenant(data: SelectTenantRequest): Promise<SelectTenantResponse> {
  const res = await api.post<SelectTenantResponse>(`${AUTH}/select-tenant`, data);
  return res.data;
}

export async function checkEmailAvailability(email: string): Promise<{ available: boolean }> {
  const res = await api.get<{ available: boolean }>(`${AUTH}/check-email`, { params: { email } });
  return res.data;
}
